export var COMPONENT_TYPE;
(function (COMPONENT_TYPE) {
    COMPONENT_TYPE["SELECT_MULTI"] = "selectMulti";
    COMPONENT_TYPE["SELECT"] = "select";
    COMPONENT_TYPE["INPUT"] = "input";
    COMPONENT_TYPE["ADDRESS"] = "address";
})(COMPONENT_TYPE || (COMPONENT_TYPE = {}));
